<div
    class="container-fluid"
    data-test-automation="former-tenure-detail">
    <div class="row">
        <div class="col-xs-4">
            <nlr-tenure-parent-plan-type
                [name]="'plan-type'+name"
                [id]="'plan-type'+name"
                [ngClass]="{'disabled':formerTenureValidityLookup.prePopParentPlan}"
                [tenure]="tenure"
                [formerTenureValidityLookup]="formerTenureValidityLookup"
                [formerTenureUiConfigLookup]="formerTenureUIConfigLookup"
                [parentPlanTypeLookups]="parentPlanTypeLookups"
                [label]="labelMap.parentPlanType"
                [tenureDisplayType]="tenureDisplayType">
            </nlr-tenure-parent-plan-type>
        </div>
        <div class="col-xs-8">
            @if (tenure.parentPlanType) {
                <div class="row">
                    <div class="col-xs-4">
                        <nlr-tenure-parent-plan-number
                            [name]="'plan-number'+name"
                            [id]="'plan-number'+name"
                            [ngClass]="{'disabled':formerTenureValidityLookup.prePopParentPlan}"
                            [tenure]="tenure"
                            [readonly]="readonly"
                            [label]="labelMap.parentPlan"
                            >>
                        </nlr-tenure-parent-plan-number>
                    </div>
                    <div class="col-xs-8">
                        <nlr-tenure-parent-lots
                            [name]="'parent-lots'+name"
                            [tenure]="tenure"
                            [label]="labelMap.parentLot"
                            [tenureNewLotsLandAttrs]="tenureDisplayType === 'FORMER_TENURE_PORTAL' || tenureDisplayType === 'FORMER_TENURE_DIGITAL'">
                        </nlr-tenure-parent-lots>
                    </div>
                </div>
            }
            @if (!tenure.parentPlanType && subjectLandTypeLookups.length > 0) {
                <div class="row">
                    <div class="col-xs-8">
                        <div class="row">
                            <nlr-tenure-subject-land
                                [id]="'subject-land'+name"
                                [name]="'subject-land'+name"
                                [tenure]="tenure"
                                [formerTenureValidityLookup]="formerTenureValidityLookup"
                                [parentPlanTypeLookups]="parentPlanTypeLookups"
                                [subjectLandTypeLookups]="subjectLandTypeLookups"
                                [titleReferenceLabel]="formerTenureUIConfigLookup.titleReferenceLabel"
                                [label]="labelMap.subjectLandDescription">
                            </nlr-tenure-subject-land>
                        </div>
                    </div>
                    @if ((tenureDisplayType === 'FORMER_TENURE_PORTAL' || this.tenureDisplayType === 'FORMER_TENURE_DIGITAL') && tenure.newLotDetails) {
                        <div class="col-xs-4">
                            <nlr-tenure-new-lot-detail
                                [name]="'new-lot'+name"
                                [newLotDetails]="tenure.newLotDetails"></nlr-tenure-new-lot-detail>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
